import React, { useEffect } from 'react';
import { useRoutes } from 'react-router-dom';
import { ThemeProvider } from '@material-ui/core';
import 'src/mixins/chartjs';
import Styles from '@config/Styles';
import Theme from '@config/Theme';
import Routes from '@config/Routes';
import { auth } from '@config/Firebase';
import Storage from '@utils/Storage';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';

const Application = () => {
  const applicationRoute = useRoutes(Routes);
  useEffect(() => {
    auth.onAuthStateChanged(authState => {
      if (authState) {
        Storage.set('userInfo', authState);
      } else {
        Storage.remove('userInfo');
      }
    });
  }, []);

  return (
    <MuiPickersUtilsProvider utils={MomentUtils}>
      <ThemeProvider theme={Theme}>
        <Styles />
        {applicationRoute}
      </ThemeProvider>
    </MuiPickersUtilsProvider>
  );
};

export default Application;
